export default {
  computed: {
    pageTitle() {
      return this.$store.state.website.page.title
    },
    pageKeywords() {
      return this.$store.state.website.page.keywords
    },
    pageDescription() {
      return this.$store.state.website.page.description
    },
    twitterImage() {
      if (this.$store.state.betterme === 'bettermeedu') {
        return 'https://download-pa-s3.thethinkacademy.com/frontend/2025/02/20/7fguiwsgoj.png'
      }
      return 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/common/brand-logo-square.jpg'
    },
  },
  head() {
    const defaultTitle = this.$t('common.websiteName')
    return {
      title: this.pageTitle || defaultTitle,
      meta: [
        {
          name: 'keywords',
          content: this.pageKeywords,
        },
        {
          name: 'description',
          content: this.pageDescription,
        },
        // 添加Twitter相关元标签
        {
          name: 'twitter:card',
          content: 'summary_large_image',
        },
        {
          name: 'twitter:title',
          content: this.pageTitle || defaultTitle,
        },
        {
          name: 'twitter:description',
          content: this.pageDescription || this.$t('seo.description'),
        },
        {
          name: 'twitter:image',
          content: this.twitterImage,
        },
      ],
    }
  },
}
